import { useEffect } from 'react';
import { useStoreActions, useStoreState } from 'react-flow-renderer';

/** Realizar alguns efeitos extras quando o fluxo e alterado.
 *
 *  Utiliza o estado interno do ReactFlow
 *
 * @param {*} selectedNodes lista do nós selecionado
 */
export const ReactFlowExtraEffects = ({ selectedNodes }) => {
  const internatlNodes = useStoreState((store) => store.nodes);
  const setSelectedElements = useStoreActions((actions) => actions.setSelectedElements);

  useEffect(() => {
    if (selectedNodes) {
      setSelectedElements(internatlNodes.filter((node) => selectedNodes.includes(node.id)));
    }
  }, [selectedNodes]);

  return null;
};

export default ReactFlowExtraEffects;
